module.exports = __webpack_public_path__ + "media/images/landing_page/screen_mobile-d54669e3b6d25436f7de7d3348205660.png";